module.exports = __webpack_public_path__ + "static/header4-f3954b9689afdad8459823b1cd530d11.jpg";